import { Alert, Badge, Button, Card, EmptyState, PageHeading, useToast } from '@aulaviva/ui';
import { CalendarClock, Copy, Laptop, MonitorPlay, Radio } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useWebinarRegia } from '@/api/gestione';
import { formattaIntervallo } from '@/lib/date';
import { admin, comuni, regia as t } from '@/testi';

export function WebinarRegia() {
  const webinar = useWebinarRegia();
  const toast = useToast();
  const navigate = useNavigate();

  async function copia(chiave: string) {
    try {
      await navigator.clipboard.writeText(chiave);
      toast.mostra({ variant: 'success', title: t.copiata });
    } catch {
      toast.mostra({ variant: 'error', title: comuni.erroreGenerico });
    }
  }

  return (
    <>
      <PageHeading subtitle={t.sottitolo}>{t.titolo}</PageHeading>
      {webinar.isPending && <p className="t-body text-ink-muted">{comuni.caricamento}</p>}
      {webinar.isError && <Alert variant="error" title={webinar.error.message} action={<Button onClick={() => webinar.refetch()}>{comuni.riprova}</Button>} />}
      {webinar.data?.length === 0 && (
        <EmptyState icon={CalendarClock} title={t.nessunoTitolo}>
          {t.nessunoTesto}
        </EmptyState>
      )}
      <div className="flex flex-col gap-6">
        {webinar.data?.map((w) => (
          <Card key={w.id} className="flex flex-col gap-4">
            <div className="flex flex-wrap justify-between gap-2">
              <p className="t-body-small text-ink-muted">{formattaIntervallo(w.inizioPrevisto, w.finePrevista)}</p>
              <Badge variant={w.stato === 'in_diretta' ? 'accent' : 'neutral'}>{admin.statiWebinar[w.stato]}</Badge>
            </div>
            <h2 className="t-title-3">{w.titolo}</h2>
            <p className="t-body inline-flex items-center gap-2">
              {w.modalitaIngresso === 'regia' ? <Radio aria-hidden size={20} strokeWidth={1.75} /> : <Laptop aria-hidden size={20} strokeWidth={1.75} />}
              {w.modalitaIngresso === 'regia' ? t.modalitaRegia : t.modalitaRelatore}
            </p>
            {w.modalitaIngresso === 'regia' && (
              <div className="flex flex-col gap-2">
                <span className="t-label text-ink-muted">{t.chiave}</span>
                <div className="flex flex-wrap items-center gap-3">
                  <code className="t-code bg-surface-sunken rounded-md px-3 py-2 break-all">{w.streamKey}</code>
                  <Button icon={Copy} onClick={() => copia(w.streamKey)}>
                    {t.copia}
                  </Button>
                </div>
              </div>
            )}
            <Button icon={MonitorPlay} onClick={() => navigate(`/regia/webinar/${w.id}`)} className="self-start">
              {t.apri}
            </Button>
          </Card>
        ))}
      </div>
    </>
  );
}
